export const NEW_ORDER_PAGE = 'NewOrder'
export const ORDER_RESTART = 'OrderRepeat'
export const ORDER_EDIT = 'OrderEdit'

export const ORDER_FORM_PAGES_LIST = [NEW_ORDER_PAGE, ORDER_RESTART, ORDER_EDIT]
export const HIDDEN_ROUTES = [
  // 'PickupCenters',
  // 'AddPickupPoint',
  // 'EditPickupPoint',
  // 'PickupCenterList',
  // 'Verification',
]
export const FIRST_LEVEL_ROUTE_INDEX = 2
export const HOME_ROUTE = 'OrdersList'
